import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ExecutionStatus } from "../../../core/enum/ExecutionStatus";
import { SearchStateType } from "../../../Orchestrator/Types/Index";
import { LocationPermission } from "../../../Orchestrator/Types/Types/FmlmSearch/FmlmSearchType";
import { getReverseGeocodedLocation } from "../../LogicActions/FmlmSearch/FmlmGeoService";

export class OpenCloseLocationMap extends BaseAction<
  void,
  {
    isVisible: boolean;
    locationFor?: string;
    search?: SearchStateType;
    locationPermission?: LocationPermission;
  }
> {
  override async run(): Promise<void | null> {
    try {
      const { isVisible, locationFor, search, locationPermission } = this.params!;
      if (!isVisible) {
        updateRecoilState("locationDataAtom", []);
        updateRecoilState("selectedLocationAtom", null);
        updateRecoilState("selectedLocationDestinationAtom", null);
        updateRecoilState("fmlmReverseGeoCodeLocationAtom", null);
        updateRecoilState("currentLocationAtom", null);
      }
      if (locationPermission?.isGranted && locationPermission?.position) {
        const location = await getReverseGeocodedLocation(
          locationPermission?.position?.coords.longitude,
          locationPermission?.position?.coords.latitude
        );
        if (location) {
          updateRecoilState("currentLocationAtom", location);
        }
      }
      updateRecoilState("locationMapVisibleAtom", isVisible);
      this.status.executionStatus = ExecutionStatus.SUCCESS;
    } catch (error) {
      console.log("Error in OpenCloseLocationMap:", error);
      console.error("Error in FavouriteStopAction:", error);
      this.status.executionStatus = ExecutionStatus.ERROR;
    }
  }
}

// Create a singleton instance
export const opencloseLocationMap = new OpenCloseLocationMap();
